;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { event } from '../utils/gtag';
import axiosInstance from '../utils/axios';

const app = process.env.NEXT_PUBLIC_APP;

export const uploadContactForm = async (body) => {
  const { data } = await axiosInstance.post(`/business/contact`, body);
  event({
    action: 'businessContactFormSubmission',
    category: app || 'synergiejobs.be',
    label: '',
    value: body.job,
  });
  return data;
};
